"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorService = void 0;
var tinycolor2_1 = __importDefault(require("tinycolor2"));
var tinygradient_1 = __importDefault(require("tinygradient"));
var defineFormats = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args;
};
var acceptedFormats = defineFormats("hexString", "hex8String", "hsl", "hslString", "hsv", "hsvString", "rgb", "rgbString");
// export type ColorFormat = 'hexString' | 'hex8String' | 'hsl' | 'hslString' | 'hsv' | 'hsvString' | 'rgb' | 'rgbString';
var colorFormatFunctions = {
    hexString: "toHexString",
    hex8String: "toHex8String",
    hsl: "toHsl",
    hslString: "toHslString",
    hsv: "toHsv",
    hsvString: "toHsvString",
    rgb: "toRgb",
    rgbString: "toRgbString",
};
/** Service providing color utilities, including fetching discrete and continuous color ranges */
var ColorService = /** @class */ (function () {
    function ColorService() {
        var _this = this;
        /** Get an array of n discrete colors given a starting palette, requested number of stops n, and other
         * options, inculding transparency, return format, whether to interpolate and/or reverse
         */
        this.getDiscreteRange = function (options) {
            var stops = options.stops, range = options.palette, reverse = options.reverse, limitPalette = options.limitToPalette, _a = options.format, format = _a === void 0 ? "hexString" : _a, _b = options.alpha, alpha = _b === void 0 ? 1 : _b;
            // ensure we've received a valid format
            if (!acceptedFormats.includes(format)) {
                throw new Error("ColorService: invalid color format");
            }
            // tinygradient doesn't handle unexpected values perfectly, so normalize them through tinycolor first. If no
            // colors are provided we're working with black :)
            var colorArray = range && range.length
                ? range.map(function (c) { return new tinycolor2_1.default(c); })
                : [new tinycolor2_1.default("black")];
            var rangeLength = colorArray.length;
            // If we are requesting one (or fewer!) stops, just return the first color in the array.
            if (stops <= 1) {
                var tc = reverse ? colorArray.pop() : colorArray[0];
                return [
                    tc &&
                        tc.setAlpha(alpha * tc.getAlpha())[colorFormatFunctions[format]](),
                ];
            }
            // TinyGradient doesn't like it when we pass a large color array, then request back fewer stops.
            // So we need to reduce the size of the array. If we're limited to specified colors, just grab the
            // first part of the array. Otherwise, map the array to a reduced set.
            if (stops < rangeLength) {
                var length_1 = colorArray.length;
                var reducedColorArray = [];
                for (var i = 0; i < stops; i++) {
                    if (limitPalette) {
                        reducedColorArray.push(colorArray[i]);
                    }
                    else {
                        reducedColorArray.push(colorArray[Math.round(_this.mapNumberFromTo(i, 0, stops - 1, 0, length_1 - 1))]);
                    }
                }
                colorArray = reducedColorArray;
            }
            // If we have more stops than we do specified colors AND we're limited to using specified colors,
            // Then let's... repeat the array and hope for the best?
            if (stops > rangeLength && limitPalette) {
                var stopDiff = stops - rangeLength;
                for (var i = 0; i < stopDiff; i++) {
                    colorArray.push(colorArray[i]);
                }
            }
            // TinyGradient can take TinyColors directly
            var gradient = new tinygradient_1.default(colorArray);
            if (reverse) {
                gradient = gradient.reverse();
            }
            return gradient
                .rgb(stops)
                .map(function (tc) {
                return tc.setAlpha(alpha * tc.getAlpha())[colorFormatFunctions[format]]();
            });
        };
        /** Construct a css linear-gradient (without prefix) given the direction, color ranges, and whether to reverse */
        this.getCssGradient = function (options) {
            var direction = options.direction, range = options.palette, reverse = options.reverse;
            var colors = range ? range.map(function (c) { return new tinycolor2_1.default(c); }) : [];
            if (colors.length < 1) {
                colors.push(new tinycolor2_1.default("black"));
            }
            if (colors.length < 2) {
                colors.push(new tinycolor2_1.default("black"));
            }
            var gradient = new tinygradient_1.default(colors);
            if (reverse) {
                gradient = gradient.reverse();
            }
            return gradient.css(undefined, direction);
        };
        /** Get a single color from a palette, at a specific point along its gradient */
        this.getColorFromPalette = function (options) {
            var _a = options.alpha, alpha = _a === void 0 ? 1 : _a, _b = options.format, colorFormat = _b === void 0 ? "hexString" : _b, palette = options.palette, _c = options.position, percentage = _c === void 0 ? 0 : _c, reverse = options.reverse;
            var colors = reverse ? __spreadArray([], palette, true).reverse() : palette;
            var gradient = new tinygradient_1.default(colors.map(function (c) {
                var color = new tinycolor2_1.default(c);
                return color.setAlpha(alpha * color.getAlpha());
            }));
            return gradient.rgbAt(percentage)[colorFormatFunctions[colorFormat]]();
        };
        this.mapNumberFromTo = function (num, minA, maxA, minB, maxB) { return ((num - minA) / (maxA - minA)) * (maxB - minB) + minB; };
    }
    return ColorService;
}());
// singleton instance of the service:
exports.colorService = new ColorService();
